import React from 'react';
import { useTranslation } from 'react-i18next';
import { EXAM_TYPE } from '../../../../routes/ExamRoute';
import Instructions from '../AEIS/Instructions';

const NonNationalSpersTypeExam = ({
  examType,
  examTitle,
  path,
}: {
  examType: string;
  examTitle: string;
  path: string;
}) => {
  const { t } = useTranslation();

  return (
    <Instructions
      instructionTitle={
        examType === EXAM_TYPE.SPERS
          ? t('exam->>IndividualRegistration.InstructionsForSPE')
          : t('exam->>IndividualRegistration.InstructionsForSPERSSec')
      }
      examType={examType}
      examTitle={examTitle}
      path={path}
    />
  );
};

export default NonNationalSpersTypeExam;
